/*
*###############################################################################
*Module Name                   : DPSearchBox.js                                #
*Purpose of the Module         : Search ModalUI                                #
*Description of the Module     : Common Search Modal Component with Table      #
*Original Author               :  T A C Priyashad                              #
*Date                          : Sunday, August 22nd 2021, 7:35:18 am          #
*Copyright (c) 2021 myPOS Software Solution (pvt Ltd.)                         #
*###############################################################################
*/
import React, { useEffect, useState } from "react";
import ReactPaginate from "react-paginate";
import { Row, Col, Modal } from "reactstrap"

const DPVoucherErrorPopup = (props) => {

    const [page, setPage] = useState(1);
    const [search, setSearch] = useState("");
    const [searchBy, setSearchBy] = useState("strCode")

    useEffect(() => {
        setPage(1)
        setSearch("")
        setSearchBy("GP_CODE")
    }, [props.isOpen])


    const handlePageClick = (event) => {
        setPage(event.selected + 1);
    };


    const indexOfLastPost = page * 10
    const indexOfFirstPost = indexOfLastPost - 10
    const currentDetailRows = props.data.slice(indexOfFirstPost, indexOfLastPost)

 
    return (
        <div>
            <Modal
                size="sm"
                isOpen={props.isOpen}
                toggle={props.toggle}
            >
                <div className="modal-header">
                    <h5
                        className="modal-title mt-0"
                        id="myExtraLargeModalLabel"
                    >
                        {props.mainTitle}
                    </h5>
                    <button
                        onClick={props.toggle}
                        type="button"
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                    >
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div className="modal-body">
          
                    <Row>
                        <Col className="col-12">
                            <table className="table table-sm table-bordered table-hover">
                                <thead className="table-light" >
                                    <tr>
                                        <th style={{ width: "20px" }}>#</th>
                                        <th style={{ width: "50px" }}>Code</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {currentDetailRows.map((item, index) => {
                                          return (
                                            <tr key={index}>
                                                <td>{indexOfFirstPost + index + 1}</td>
                                                <td>{item.strCode}</td>
                                            </tr>
                                        )
                                    })}
                                </tbody>
                            </table>
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={12} md={12} className="mb-12-sm">
                            <ReactPaginate
                                previousLabel={'Previous'}
                                nextLabel={'Next'}
                                breakLabel={'...'}
                                pageClassName="page-item"
                                pageLinkClassName="page-link"
                                previousClassName="page-item"
                                previousLinkClassName="page-link"
                                nextClassName="page-item"
                                nextLinkClassName="page-link"
                                breakClassName="page-item"
                                breakLinkClassName="page-link"
                                pageCount={Math.ceil(props.data.length / 10)}
                                pageRangeDisplayed={2}
                                onPageChange={handlePageClick}
                                forcePage={page - 1}
                                renderOnZeroPageCount={null}
                                activeClassName={'active'}
                                activeLinkClassName={'page-link'}
                                containerClassName={'pagination justify-content-end pagination-sm'}
                            />
                        </Col>
                    </Row>
                </div>
            </Modal>

        </div>
    );
}

export default DPVoucherErrorPopup;